<template>
    <div>
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>
        <PagePreloader v-if="resultsAreLoading">search results</PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- Only display if page is loaded -->
        <template v-if="pageIsReady">
            <!-- NOTE - Search Card -->
            <div class="card card-custom gutter-b">
                <div class="card-body p-0">
                    <div class="wizard wizard-2">
                        <!-- NOTE - Navigation -->
                        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
                            <div class="wizard-steps">
                                <div
                                    class="wizard-step"
                                    data-wizard-type="step"
                                    :data-wizard-state="isWizardStep('basic')"
                                    @click="setWizardStep('basic')"
                                >
                                    <div class="wizard-wrapper">
                                        <div class="wizard-icon">
                                            <span class="svg-icon svg-icon-2x">
                                                <inline-svg
                                                    src="media/svg/icons/General/Thunder-move.svg"
                                                />
                                            </span>
                                        </div>
                                        <div class="wizard-label">
                                            <h3 class="wizard-title">Search Parameters</h3>
                                            <div class="wizard-desc">Define your search terms</div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="wizard-step"
                                    data-wizard-type="step"
                                    :data-wizard-state="isWizardStep('advanced')"
                                    @click="setWizardStep('advanced')"
                                >
                                    <div class="wizard-wrapper">
                                        <div class="wizard-icon">
                                            <span class="svg-icon svg-icon-2x">
                                                <inline-svg
                                                    src="media/svg/icons/Map/Position.svg"
                                                />
                                            </span>
                                        </div>
                                        <div class="wizard-label">
                                            <h3 class="wizard-title">Advanced Options</h3>
                                            <div class="wizard-desc">Fine-tune your query</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- NOTE - Main menu -->
                        <div class="wizard-body py-8 px-8 pt-lg-20 px-lg-10">
                            <!--begin: Wizard Form-->
                            <div class="row">
                                <div class="px-5">
                                    <!-- <div class="offset-xxl-2 col-xxl-8"> -->
                                    <form
                                        class="form"
                                        id="kt_form"
                                        ref="hashtagSearchForm"
                                        v-on:submit.prevent="doHashtagSearch"
                                    >
                                        <!--begin: Wizard Step 1-->
                                        <div
                                            class="pb-5"
                                            data-wizard-type="step-content"
                                            :data-wizard-state="isWizardStep('basic')"
                                        >
                                            <h4 class="mb-10 font-weight-bold text-dark">
                                                Enter your Search Terms
                                            </h4>
                                            <div class="form-group">
                                                <label>Hashtag</label>
                                                <input
                                                    type="text"
                                                    class="
                                                        form-control
                                                        form-control-solid
                                                        form-control-lg
                                                    "
                                                    placeholder="Enter your hashtag here"
                                                    v-model="form.hashtags"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <label>Your average number of likes</label>
                                                <input
                                                    type="number"
                                                    class="
                                                        form-control
                                                        form-control-solid
                                                        form-control-lg
                                                        w-100
                                                    "
                                                    placeholder="(Optional)"
                                                    v-model="form.likes"
                                                />
                                            </div>
                                            <!-- Search Mode -->
                                            <div class="form-group">
                                                <!-- <label>Search Mode</label> -->
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <label class="option option-plain">
                                                            <span class="option-control">
                                                                <span class="radio">
                                                                    <input
                                                                        type="radio"
                                                                        name="mode"
                                                                        value="1"
                                                                        checked="checked"
                                                                        v-model="form.selectedMode"
                                                                    />
                                                                    <span></span>
                                                                </span>
                                                            </span>
                                                            <span class="option-label">
                                                                <span class="option-head">
                                                                    <span class="option-title">
                                                                        Filter Daily Posts
                                                                    </span>
                                                                    <span class="option-focus">
                                                                    </span>
                                                                </span>
                                                                <span class="option-body">
                                                                    Filter by amount of average
                                                                    daily posts on your queried
                                                                    hashtags.
                                                                </span>
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div class="col-lg-6">
                                                        <label class="option option-plain">
                                                            <span class="option-control">
                                                                <span class="radio">
                                                                    <input
                                                                        type="radio"
                                                                        name="mode"
                                                                        value="2"
                                                                        v-model="form.selectedMode"
                                                                    />
                                                                    <span></span>
                                                                </span>
                                                            </span>
                                                            <span class="option-label">
                                                                <span class="option-head">
                                                                    <span class="option-title">
                                                                        Filter Total Posts
                                                                    </span>
                                                                    <span class="option-focus">
                                                                    </span>
                                                                </span>
                                                                <span class="option-body">
                                                                    Filter by overall total amount
                                                                    of posts on your queried
                                                                    hashtags.
                                                                </span>
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div class="col-lg-6">
                                                        <label class="option option-plain">
                                                            <span class="option-control">
                                                                <span class="radio">
                                                                    <input
                                                                        type="radio"
                                                                        name="mode"
                                                                        value="3"
                                                                        v-model="form.selectedMode"
                                                                    />
                                                                    <span></span>
                                                                </span>
                                                            </span>
                                                            <span class="option-label">
                                                                <span class="option-head">
                                                                    <span class="option-title">
                                                                        Daily Posts Ladder
                                                                    </span>
                                                                    <span class="option-focus">
                                                                    </span>
                                                                </span>
                                                                <span class="option-body">
                                                                    Split search results by brackets
                                                                    based on number of daily posts.
                                                                </span>
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div class="col-lg-6">
                                                        <label class="option option-plain">
                                                            <span class="option-control">
                                                                <span class="radio">
                                                                    <input
                                                                        type="radio"
                                                                        name="mode"
                                                                        value="4"
                                                                        v-model="form.selectedMode"
                                                                    />
                                                                    <span></span>
                                                                </span>
                                                            </span>
                                                            <span class="option-label">
                                                                <span class="option-head">
                                                                    <span class="option-title">
                                                                        Total Posts Ladder
                                                                    </span>
                                                                    <span class="option-focus">
                                                                        <b-badge variant="success"
                                                                            >Best</b-badge
                                                                        >
                                                                    </span>
                                                                </span>
                                                                <span class="option-body">
                                                                    Split search results by brackets
                                                                    based on total number of posts.
                                                                </span>
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- SEARCH MODE Options -->
                                            <template v-if="searchmodes">
                                                <div v-for="(searchmode, index) in searchmodes">
                                                    <div v-if="index == form.selectedMode">
                                                        <div class="form-group">
                                                            <label>{{
                                                                searchmodetitles[index]
                                                            }}</label>
                                                            <select
                                                                class="
                                                                    form-control form-control-solid
                                                                "
                                                                name="option"
                                                            >
                                                                <option
                                                                    v-for="modeoptions in searchmode"
                                                                    :value="modeoptions.value"
                                                                    :selected="
                                                                        modeoptions.value ==
                                                                        searchmodedefaults[index]
                                                                    "
                                                                >
                                                                    {{ modeoptions.text }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                        <!--end: Wizard Step 1-->

                                        <!--begin: Wizard Step 3-->
                                        <div
                                            class="pb-5"
                                            data-wizard-type="step-content"
                                            :data-wizard-state="isWizardStep('advanced')"
                                        >
                                            <h4 class="mb-10 font-weight-bold text-dark">
                                                Advanced Options
                                            </h4>
                                            <b-form-group>
                                                <b-form-checkbox
                                                    switch
                                                    class="pb-2"
                                                    v-model="form.switches.relevant"
                                                >
                                                    Include relevant hashtags
                                                    <div class="d-inline">
                                                        <span
                                                            id="tooltip-relevant"
                                                            class="svg-icon svg-icon-primary"
                                                        >
                                                            <inline-svg
                                                                src="media/svg/icons/Code/Info-circle.svg"
                                                            ></inline-svg>
                                                        </span>
                                                        <b-tooltip
                                                            target="tooltip-relevant"
                                                            triggers="hover"
                                                        >
                                                            Selecting this option enables Hashtastic
                                                            to also query additional hashtags that
                                                            are similar to your search term and adds
                                                            them to the result list.
                                                        </b-tooltip>
                                                    </div>
                                                </b-form-checkbox>
                                                <b-form-checkbox
                                                    switch
                                                    class="pb-2"
                                                    v-model="form.switches.useless"
                                                >
                                                    Remove very small hashtags
                                                    <div class="d-inline">
                                                        <span
                                                            id="tooltip-useless"
                                                            class="svg-icon svg-icon-primary"
                                                        >
                                                            <inline-svg
                                                                src="media/svg/icons/Code/Info-circle.svg"
                                                            ></inline-svg>
                                                        </span>
                                                        <b-tooltip
                                                            target="tooltip-useless"
                                                            triggers="hover"
                                                        >
                                                            This option removes hashtags with less
                                                            than 5000 posts from your results.
                                                        </b-tooltip>
                                                    </div>
                                                </b-form-checkbox>
                                                <b-form-checkbox
                                                    switch
                                                    class="pb-2"
                                                    v-model="form.switches.smarttags"
                                                >
                                                    Automatically select best hashtags
                                                    <div class="d-inline">
                                                        <span
                                                            id="tooltip-magic"
                                                            class="svg-icon svg-icon-primary"
                                                        >
                                                            <inline-svg
                                                                src="media/svg/icons/Code/Info-circle.svg"
                                                            ></inline-svg>
                                                        </span>
                                                        <b-tooltip
                                                            target="tooltip-magic"
                                                            triggers="hover"
                                                        >
                                                            By enabling this option, Hashtastic will
                                                            automatically offer a selection of some
                                                            of the best hashtags from your results,
                                                            based on their relative Post Count and
                                                            Daily Posts.
                                                        </b-tooltip>
                                                    </div>
                                                </b-form-checkbox>
                                                <b-form-checkbox
                                                    switch
                                                    class="pb-2"
                                                    v-model="form.switches.getbanned"
                                                >
                                                    Included banned hashtags in query
                                                    <div class="d-inline">
                                                        <span
                                                            id="tooltip-banned"
                                                            class="svg-icon svg-icon-primary"
                                                        >
                                                            <inline-svg
                                                                src="media/svg/icons/Code/Info-circle.svg"
                                                            ></inline-svg>
                                                        </span>
                                                        <b-tooltip
                                                            target="tooltip-banned"
                                                            triggers="hover"
                                                        >
                                                            This option forces Hashtastic to display
                                                            every banned hashtag similar to your
                                                            search parameters.
                                                        </b-tooltip>
                                                    </div>
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </div>
                                        <!--end: Wizard Step 3-->

                                        <!--begin: Wizard Actions -->
                                        <div
                                            class="d-flex justify-content-between border-top pt-10"
                                        >
                                            <div>
                                                <button
                                                    class="
                                                        btn btn-success
                                                        font-weight-bold
                                                        text-uppercase
                                                        px-9
                                                        py-4
                                                    "
                                                    type="submit"
                                                    :disabled="resultsAreLoading"
                                                >
                                                    Search
                                                </button>
                                                <!-- Hidden submit button -->
                                                <b-button
                                                    variant="success"
                                                    type="Submit"
                                                    class="d-none"
                                                    :disabled="resultsAreLoading"
                                                >
                                                    Search
                                                </b-button>
                                            </div>
                                        </div>
                                        <!--end: Wizard Actions -->
                                    </form>
                                </div>
                                <!--end: Wizard-->
                            </div>
                        </div>
                        <!--end: Wizard Body -->
                    </div>
                </div>
            </div>
            <!-- END Search card -->

            <!-- NOTE - Start displaying search results -->
            <div v-if="displayResults" class="row search-results-block">
                <!-- NOTE - Nav bar -->
                <div class="col-xl-3">
                    <!--begin::Card-->
                    <div class="card card-custom card-stretch gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <span class="card-icon">
                                    <i class="fas fa-history text-success"></i>
                                </span>
                                <h3 class="card-label">Search History</h3>
                            </div>
                        </div>
                        <!--begin::Body-->
                        <div class="card-body px-5">
                            <!--begin:Nav-->
                            <div
                                class="
                                    navi
                                    navi-hover
                                    navi-active
                                    navi-link-rounded
                                    navi-bold
                                    navi-icon-center
                                    navi-light-icon
                                "
                            >
                                <!--begin:Section-->
                                <!-- <div
                                    class="navi-section mt-7 mb-2 font-size-h6 font-weight-bold pb-0"
                                >
                                    Search History
                                </div> -->
                                <!--end:Section-->

                                <!--begin:Item-->
                                <div
                                    class="navi-item navi-item-viral my-2"
                                    v-for="(tab, tabIndex) in tabs"
                                    :title="tab.title"
                                >
                                    <b-button
                                        variant="white"
                                        class="navi-link col-12 text-left"
                                        @click="changeTab(tabIndex)"
                                        :class="tabIndex == currentTab ? 'active' : ''"
                                    >
                                        <!-- :class="(category == currentCategory ? 'active' : '')"
                                        @click="getViralCategory(category, 1)" -->
                                        <span class="navi-icon mr-4">
                                            <span class="svg-icon svg-icon-lg">
                                                <inline-svg
                                                    src="media/svg/icons/Code/CMD.svg"
                                                ></inline-svg>
                                            </span>
                                        </span>
                                        <span class="navi-text font-weight-bolder font-size-lg"
                                            >#{{ tab.search_parameters.hashtag }}</span
                                        >
                                    </b-button>
                                </div>
                                <!--end:Item-->
                            </div>
                            <!--end:Nav-->
                        </div>
                        <!--end::Body-->
                    </div>
                    <!--end::Card-->
                </div>
                <!-- End nav bar -->

                <!-- NOTE - Main column -->
                <div class="col-xl-9">
                    <!-- NOTE - Copy hashtags section -->
                    <div class="card card-custom card-stretch gutter-b">
                        <div class="card-header">
                            <div class="card-title">
                                <span class="card-icon">
                                    <i class="fas fa-hashtag text-success"></i>
                                </span>
                                <h3 class="card-label">Selected Hashtags</h3>
                            </div>
                            <div class="card-toolbar">
                                <span
                                    class="btn btn-bold btn-sm"
                                    :class="
                                        selectedHashtags.length >= 30
                                            ? 'btn-outline-danger'
                                            : 'btn-outline-primary'
                                    "
                                >
                                    {{ selectedHashtags.length }} hashtags selected
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="selectedHashtags.length < 1">
                                <infoBox
                                    text="You currently haven't selected any hashtags. Use the tables below to make your selection."
                                ></infoBox>
                            </div>

                            <div v-if="selectedHashtags.length > 0">
                                <div class="row">
                                    <div class="col-xl-12 btn-group" style="flex-wrap: wrap">
                                        <div v-for="selectedHashtag in selectedHashtags">
                                            <span
                                                class="
                                                    btn btn-sm btn-font-sm
                                                    font-weight-bold
                                                    btn-light-primary
                                                    m-1
                                                "
                                                >#{{ selectedHashtag }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer row" v-if="selectedHashtags.length > 0">
                            <!-- NOTE - Copy to Clipboard button -->
                            <buttonCopyToClipboard
                                :propHashtags="selectedHashtagsHashed"
                                class="col-md-3 col-12"
                            ></buttonCopyToClipboard>
                            <!-- NOTE - Create new hashtag set -->
                            <buttonCreateNewHashtagSet
                                :propHashtags="selectedHashtagsHashed"
                                @emitPassMessage="handleEmitMessages"
                                class="col-md-3 col-12"
                            >
                            </buttonCreateNewHashtagSet>
                            <!-- NOTE - Add to existing hashtag set -->
                            <buttonAddToExistingHashtagSet
                                @emitPassMessage="handleEmitMessages"
                                :propHashtags="selectedHashtagsHashed"
                                class="col-md-3 col-12"
                            ></buttonAddToExistingHashtagSet>
                        </div>
                    </div>
                </div>

                <!-- NOTE - Results card -->
                <div class="col-xl-12">
                    <div class="">
                        <div class="">
                            <b-tabs
                                pills
                                content-class=""
                                class="tabs-hide w-100"
                                v-model="currentTab"
                            >
                                <b-tab
                                    v-for="(tab, tabIndex) in tabs"
                                    :title="tab.title"
                                    title-item-class="mytab"
                                    :ref="'tabsRefs-' + tabIndex"
                                >
                                    <!-- <div v-for="error in tab.messages" :key="error.index">
                                        <b-alert
                                            show
                                            dismissible
                                            fade
                                            :variant="error.type"
                                            v-html="error.message"
                                        ></b-alert>
                                    </div> -->
                                    <template v-if="tab.messages.length">
                                        <CustomAlerts
                                            :errors="tab.messages"
                                            class="gutter-b"
                                        ></CustomAlerts>
                                    </template>

                                    <!-- NOTE - Search Parameters -->
                                    <div class="card card-custom gutter-b">
                                        <!--begin::Body-->
                                        <div class="card-body d-flex flex-column">
                                            <!--begin::Items-->
                                            <div class="">
                                                <div class="row row-paddingless">
                                                    <!--begin::Item-->
                                                    <div class="col-xl-3 col-12 mb-3">
                                                        <div class="d-flex align-items-center mr-2">
                                                            <!--begin::Symbol-->
                                                            <div
                                                                class="
                                                                    symbol
                                                                    symbol-45
                                                                    symbol-light-success
                                                                    mr-4
                                                                    flex-shrink-0
                                                                "
                                                            >
                                                                <div class="symbol-label">
                                                                    <i
                                                                        class="
                                                                            fas
                                                                            fa-hashtag
                                                                            text-success
                                                                        "
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                            <!--end::Symbol-->

                                                            <!--begin::Title-->
                                                            <div>
                                                                <div
                                                                    class="
                                                                        font-size-h4
                                                                        text-dark-75
                                                                        font-weight-bolder
                                                                    "
                                                                >
                                                                    #{{
                                                                        tab.search_parameters
                                                                            .hashtag
                                                                    }}
                                                                </div>
                                                                <div
                                                                    class="
                                                                        font-size-sm
                                                                        text-muted
                                                                        font-weight-bold
                                                                        mt-1
                                                                    "
                                                                >
                                                                    Queried hashtag
                                                                </div>
                                                            </div>
                                                            <!--end::Title-->
                                                        </div>
                                                    </div>
                                                    <!--end::Item-->

                                                    <!--begin::Item-->
                                                    <div class="col-xl-3 col-12 mb-3">
                                                        <div class="d-flex align-items-center mr-2">
                                                            <!--begin::Symbol-->
                                                            <div
                                                                class="
                                                                    symbol
                                                                    symbol-45
                                                                    symbol-light-info
                                                                    mr-4
                                                                    flex-shrink-0
                                                                "
                                                            >
                                                                <div class="symbol-label">
                                                                    <i
                                                                        class="
                                                                            fas
                                                                            fa-search
                                                                            text-info
                                                                        "
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                            <!--end::Symbol-->

                                                            <!--begin::Title-->
                                                            <div>
                                                                <div
                                                                    class="
                                                                        font-size-h4
                                                                        text-dark-75
                                                                        font-weight-bolder
                                                                    "
                                                                >
                                                                    {{ tab.search_parameters.mode }}
                                                                </div>
                                                                <div
                                                                    class="
                                                                        font-size-sm
                                                                        text-muted
                                                                        font-weight-bold
                                                                        mt-1
                                                                    "
                                                                >
                                                                    Search Mode
                                                                </div>
                                                            </div>
                                                            <!--end::Title-->
                                                        </div>
                                                    </div>
                                                    <!--end::Item-->

                                                    <!--begin::Item-->
                                                    <div class="col-xl-3 col-12 mb-3">
                                                        <div class="d-flex align-items-center mr-2">
                                                            <!--begin::Symbol-->
                                                            <div
                                                                class="
                                                                    symbol
                                                                    symbol-45
                                                                    symbol-light-warning
                                                                    mr-4
                                                                    flex-shrink-0
                                                                "
                                                            >
                                                                <div class="symbol-label">
                                                                    <i
                                                                        class="
                                                                            fas
                                                                            fa-filter
                                                                            text-warning
                                                                        "
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                            <!--end::Symbol-->

                                                            <!--begin::Title-->
                                                            <div>
                                                                <div
                                                                    class="
                                                                        font-size-h4
                                                                        text-dark-75
                                                                        font-weight-bolder
                                                                    "
                                                                >
                                                                    {{
                                                                        tab.search_parameters
                                                                            .options
                                                                    }}
                                                                </div>
                                                                <div
                                                                    class="
                                                                        font-size-sm
                                                                        text-muted
                                                                        font-weight-bold
                                                                        mt-1
                                                                    "
                                                                >
                                                                    Search Mode Settings
                                                                </div>
                                                            </div>
                                                            <!--end::Title-->
                                                        </div>
                                                    </div>
                                                    <!--end::Item-->

                                                    <!--begin::Item-->
                                                    <div class="col-xl-3 col-12 mb-3">
                                                        <div class="d-flex align-items-center mr-2">
                                                            <!--begin::Symbol-->
                                                            <div
                                                                class="
                                                                    symbol
                                                                    symbol-45
                                                                    symbol-light-danger
                                                                    mr-4
                                                                    flex-shrink-0
                                                                "
                                                            >
                                                                <div class="symbol-label">
                                                                    <i
                                                                        class="
                                                                            fas
                                                                            fa-heart
                                                                            text-danger
                                                                        "
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                            <!--end::Symbol-->

                                                            <!--begin::Title-->
                                                            <div>
                                                                <div
                                                                    class="
                                                                        font-size-h4
                                                                        text-dark-75
                                                                        font-weight-bolder
                                                                    "
                                                                >
                                                                    {{
                                                                        tab.search_parameters.likes
                                                                    }}
                                                                </div>
                                                                <div
                                                                    class="
                                                                        font-size-sm
                                                                        text-muted
                                                                        font-weight-bold
                                                                        mt-1
                                                                    "
                                                                >
                                                                    Number of likes
                                                                </div>
                                                            </div>
                                                            <!--end::Title-->
                                                        </div>
                                                    </div>
                                                    <!--end::Item-->
                                                </div>
                                            </div>
                                            <!--end::Items-->
                                        </div>
                                        <!--end::Body-->
                                    </div>
                                    <!-- End:: Search Parameters -->

                                    <!-- NOTE - Likes legend -->
                                    <div v-if="tab.search_parameters.hasLikes">
                                        <LikesLegend></LikesLegend>
                                    </div>

                                    <!-- NOTE - Smart tags -->
                                    <template v-if="tab.search_parameters.smart">
                                        <div class="gutter-b">
                                            <!-- Collapse button -->
                                            <b-button
                                                v-b-toggle="'collapse-' + tabIndex"
                                                variant="white"
                                                class="
                                                    col-12
                                                    text-left
                                                    font-weight-bold font-size-h4
                                                "
                                            >
                                                <span class="when-opened">
                                                    <i class="fas fa-chevron-down text-success"></i>
                                                </span>
                                                <span class="when-closed">
                                                    <i
                                                        class="fas fa-chevron-right text-success"
                                                    ></i>
                                                </span>
                                                Automatic hashtags</b-button
                                            >

                                            <!-- Element to collapse -->
                                            <b-collapse :id="'collapse-' + tabIndex">
                                                <div class="card card-custom gutter-b">
                                                    <div class="card-body pb-0">
                                                        <div class="row">
                                                            <div class="col-xl-12">
                                                                <InfoBox
                                                                    text="The following hashtags were selected automatically as being the hashtags with the best competitiveness / popularity ratio, and can serve as a good basis to start putting together your hashtag sets."
                                                                ></InfoBox>
                                                            </div>
                                                            <!-- Start smart hashtags -->
                                                            <template
                                                                v-for="(sets, type) in tab.smart"
                                                            >
                                                                <template v-for="set in sets">
                                                                    <div class="col-xl-6">
                                                                        <div
                                                                            class="
                                                                                card card-custom
                                                                                gutter-b
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    card-header
                                                                                    border-0
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="
                                                                                        card-title
                                                                                        align-items-start
                                                                                        flex-column
                                                                                        pt-5
                                                                                    "
                                                                                >
                                                                                    <h3
                                                                                        class="
                                                                                            card-label
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            v-if="
                                                                                                type ==
                                                                                                'chunks'
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                set
                                                                                                    .data
                                                                                                    .length
                                                                                            }}
                                                                                            Automatically
                                                                                            selected
                                                                                            hashtags
                                                                                        </div>
                                                                                        <div
                                                                                            v-if="
                                                                                                type ==
                                                                                                'spaced'
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                set
                                                                                                    .data
                                                                                                    .length
                                                                                            }}
                                                                                            Evenly
                                                                                            spaced
                                                                                            hashtags
                                                                                        </div>
                                                                                    </h3>
                                                                                    <span
                                                                                        class="
                                                                                            text-muted
                                                                                            font-weight-bold
                                                                                            font-size-sm
                                                                                            mt-1
                                                                                        "
                                                                                    >
                                                                                        From
                                                                                        {{
                                                                                            abbreviateNumber(
                                                                                                set.min
                                                                                            )
                                                                                        }}
                                                                                        to
                                                                                        {{
                                                                                            abbreviateNumber(
                                                                                                set.max
                                                                                            )
                                                                                        }}
                                                                                        posts
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="
                                                                                    card-body
                                                                                    pt-0
                                                                                "
                                                                            >
                                                                                <div class="row">
                                                                                    <div
                                                                                        class="
                                                                                            col-xl-12
                                                                                            btn-group
                                                                                            flex-wrap
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            v-for="selectedHashtag in set.data"
                                                                                        >
                                                                                            <span
                                                                                                class="
                                                                                                    label
                                                                                                    label-light-primary
                                                                                                    label-inline
                                                                                                    font-weight-bolder
                                                                                                    mr-2
                                                                                                    mb-2
                                                                                                "
                                                                                                >#{{
                                                                                                    selectedHashtag
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="
                                                                                    card-footer
                                                                                    btn-group
                                                                                "
                                                                            >
                                                                                <button
                                                                                    class="
                                                                                        btn
                                                                                        btn-success
                                                                                        copy-hashtags-button
                                                                                        col-12
                                                                                        col-xl-6
                                                                                        mb-1
                                                                                    "
                                                                                >
                                                                                    <i
                                                                                        class="
                                                                                            far
                                                                                            fa-clipboard
                                                                                        "
                                                                                    ></i>
                                                                                    <span
                                                                                        class="
                                                                                            innerText
                                                                                        "
                                                                                        >Copy to
                                                                                        clipboard</span
                                                                                    >
                                                                                </button>
                                                                                <p
                                                                                    style="
                                                                                        position: absolute;
                                                                                        left: -99999999em;
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        hashHashtags(
                                                                                            set.data
                                                                                        )
                                                                                    }}
                                                                                </p>
                                                                                <button
                                                                                    class="
                                                                                        btn
                                                                                        btn-primary
                                                                                        col-12
                                                                                        col-xl-6
                                                                                        mb-1
                                                                                    "
                                                                                    @click="
                                                                                        selectFromSmart(
                                                                                            tabIndex,
                                                                                            set.data
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <i
                                                                                        class="
                                                                                            fas
                                                                                            fa-object-group
                                                                                        "
                                                                                    ></i
                                                                                    >Select all
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </template>

                                    <!-- <infoBox text="Use the table below to make your hashtag selections." class="gutter-b"></infoBox> -->

                                    <!-- Modes 1 & 2 -->
                                    <div class="card card-custom">
                                        <div class="card-header">
                                            <div class="card-title">Results</div>
                                            <div class="card-toolbar">
                                                <div class="btn-group">
                                                    <b-button
                                                        variant="light-primary"
                                                        size="sm"
                                                        @click="selectAll(tabIndex, tab.mode)"
                                                        >Select All</b-button
                                                    >
                                                    <b-button
                                                        variant="light-danger"
                                                        size="sm"
                                                        @click="deselectAll(tabIndex, tab.mode)"
                                                        >Deselect All</b-button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="tab.mode == 1 || tab.mode == 2">
                                            <b-table
                                                striped
                                                hover
                                                selectable
                                                bordered
                                                select-mode="multi"
                                                @row-clicked="
                                                    (item) => onRowClicked(tab.slug, item)
                                                "
                                                :fields="fields"
                                                :items="tab.data"
                                                :per-page="15"
                                                :current-page="tab.currentpage"
                                                sortBy="count"
                                                :sortDesc="true"
                                                :sort-compare="customTableSort"
                                                responsive="sm"
                                                ref="selectableTable"
                                                class="mb-0"
                                            >
                                                <template
                                                    v-slot:cell(selected)="{ item, field: { key } }"
                                                >
                                                    <template v-if="item[key]">
                                                        <span aria-hidden="true"
                                                            ><i
                                                                class="
                                                                    far
                                                                    fa-check-square
                                                                    text-primary
                                                                    font-weight-bolder
                                                                "
                                                            ></i
                                                        ></span>
                                                        <span class="sr-only">Selected</span>
                                                    </template>
                                                    <template v-else>
                                                        <span aria-hidden="true"
                                                            ><i class="far fa-square"></i
                                                        ></span>
                                                        <span class="sr-only">Not selected</span>
                                                    </template>
                                                    <!-- <b-checkbox v-model="item[key]"></b-checkbox> -->
                                                </template>

                                                <!-- Hashtag badge slot -->
                                                <template
                                                    v-slot:cell(hashtagsBadged)="{
                                                        item,
                                                        field: { key },
                                                    }"
                                                >
                                                    {{ item.hashtag }}
                                                    <span
                                                        class="badge badge-warning"
                                                        v-if="item.status == 'flagged'"
                                                        >Flagged</span
                                                    >
                                                    <span
                                                        class="badge badge-danger"
                                                        v-if="item.status == 'banned'"
                                                        >Banned</span
                                                    >
                                                </template>
                                            </b-table>
                                            <div class="card-footer">
                                                <!-- <sub>
                                                Displaying {{ tab.total_results }} hashtags in total
                                            </sub> -->
                                                <b-pagination
                                                    v-model="tab.currentpage"
                                                    :total-rows="tab.data.length"
                                                    :per-page="15"
                                                    align="center"
                                                    aria-controls="my-table"
                                                    first-number
                                                    last-number
                                                >
                                                </b-pagination>
                                            </div>
                                        </div>
                                        <div v-if="tab.mode == 3 || tab.mode == 4">
                                            <b-tabs pills content-class="mt-3" class="w-100">
                                                <b-tab
                                                    v-for="(subtab, index) in tab.data"
                                                    :title="subtab.title"
                                                >
                                                    <b-table
                                                        striped
                                                        hover
                                                        selectable
                                                        bordered
                                                        select-mode="multi"
                                                        @row-clicked="
                                                            (item) =>
                                                                onRowClicked(tab.slug + index, item)
                                                        "
                                                        :fields="fields"
                                                        :items="Object.values(subtab.data)"
                                                        :per-page="15"
                                                        :current-page="subtab.currentpage"
                                                        sortBy="count"
                                                        :sortDesc="true"
                                                        :sort-compare="customTableSort"
                                                        responsive="sm"
                                                        ref="selectableTable"
                                                        class="mb-0"
                                                    >
                                                        <template
                                                            v-slot:cell(selected)="{
                                                                item,
                                                                field: { key },
                                                            }"
                                                        >
                                                            <template v-if="item[key]">
                                                                <span aria-hidden="true"
                                                                    ><i
                                                                        class="
                                                                            far
                                                                            fa-check-square
                                                                            text-primary
                                                                            font-weight-bolder
                                                                        "
                                                                    ></i
                                                                ></span>
                                                                <span class="sr-only"
                                                                    >Selected</span
                                                                >
                                                            </template>
                                                            <template v-else>
                                                                <span aria-hidden="true"
                                                                    ><i class="far fa-square"></i
                                                                ></span>
                                                                <span class="sr-only"
                                                                    >Not selected</span
                                                                >
                                                            </template>
                                                            <!-- <b-checkbox v-model="item[key]"></b-checkbox> -->
                                                        </template>

                                                        <!-- Hashtag badge slot -->
                                                        <template
                                                            v-slot:cell(hashtagsBadged)="{
                                                                item,
                                                                field: { key },
                                                            }"
                                                        >
                                                            {{ item.hashtag }}
                                                            <span
                                                                class="badge badge-warning"
                                                                v-if="item.status == 'flagged'"
                                                                >Flagged</span
                                                            >
                                                            <span
                                                                class="badge badge-danger"
                                                                v-if="item.status == 'banned'"
                                                                >Banned</span
                                                            >
                                                        </template>
                                                    </b-table>
                                                    <div class="card-footer">
                                                        <!-- <sub>
                                                        Displaying {{ tab.total_results }} hashtags
                                                        in total
                                                    </sub> -->
                                                        <b-pagination
                                                            v-model="subtab.currentpage"
                                                            :total-rows="
                                                                Object.values(subtab.data).length
                                                            "
                                                            :per-page="15"
                                                            align="center"
                                                            aria-controls="my-table"
                                                            first-number
                                                            last-number
                                                        >
                                                        </b-pagination>
                                                    </div>
                                                </b-tab>
                                            </b-tabs>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>
<style scoped>
.tabs /deep/ .tab-pane:focus {
    outline: none;
}
/* .tabs /deep/ .mytab > .active {
    background-color: white;
    color: #1dc9b7;
    font-weight: 600;
} */
.tabs /deep/ .mytab > .active {
    background-color: #1dc9b7;
    color: white;
    font-weight: 600;
}
.tabs /deep/ .mytab > .active a {
    border-bottom: 3px;
}
.tabs /deep/ .nav-pills {
    border-style: solid;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-color: rgba(29, 201, 183, 0.1);
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
    margin-top: 1.25rem !important;
}
.navi-item-viral {
    cursor: pointer;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>
<style lang="scss">
.tabs-hide > div > .nav-pills {
    display: none;
}
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import LikesLegend from "@/view/content/Custom/LikesLegend.vue";
import InfoBox from "@/view/content/Custom/InfoBox.vue";
// Buttons
import buttonAddToExistingHashtagSet from "@/view/content/Custom/buttonAddToExistingHashtagSet.vue";
import buttonCreateNewHashtagSet from "@/view/content/Custom/buttonCreateNewHashtagSet.vue";
import buttonCopyToClipboard from "@/view/content/Custom/buttonCopyToClipboard.vue";
// Clipboard
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
// Mixins
import stringManagement from "@/mixins/stringManagement";
import hashtagTableManagement from "@/mixins/hashtagTableManagement";
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "SearchPage",
    mixins: [stringManagement, hashtagTableManagement, axiosErrorManagement],
    components: {
        PagePreloader,
        InfoBox,
        CustomAlerts,
        LikesLegend,
        buttonAddToExistingHashtagSet,
        buttonCreateNewHashtagSet,
        buttonCopyToClipboard,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,
            pageIsReady: false,
            resultsAreLoading: false,
            modalisloading: false,

            // Wizard
            currentWizardStep: "basic",

            // Tab management
            tabs: [],
            tabCount: 0,
            currentTab: 0,

            // Selection management
            allSelectedHashtags: [],
            selectedHashtags: [],

            // Error management
            errors: [],
            modalerrors: [],

            // Form management
            form: {
                hashtags: "",
                likes: "",
                selectedMode: 1,
                option: "",
                switches: {
                    useless: true,
                    relevant: true,
                    smarttags: true,
                    getbanned: false,
                },
            },

            // Fill in modes
            searchmodes: [],
            searchmodedefaults: [],
            searchmodetitles: [],
            searchmodeshorttitles: [],

            // Table management
            fields: [
                {
                    key: "selected",
                    label: "",
                },
                {
                    key: "hashtag",
                    sortable: true,
                    tdClass: "d-none",
                    thClass: "d-none",
                },
                {
                    key: "hashtagsBadged",
                    sortable: true,
                    label: "Hashtags",
                },
                {
                    key: "count",
                    sortable: true,
                    label: "Post count",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                        // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
                {
                    key: "DAPC_weekly",
                    sortable: true,
                    label: "Daily Posts",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(Math.round(value));
                        // return Math.round(value).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
                {
                    key: "score",
                    sortable: true,
                    label: "Score",
                },
                {
                    key: "avgMaxLikes",
                    sortable: true,
                    label: "Max Likes in Top 9",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                        // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
                {
                    key: "avgMinLikes",
                    sortable: true,
                    label: "Min Likes in Top 9",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                        // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
                {
                    key: "avgAvgLikes",
                    sortable: true,
                    label: "Average Likes in Top 9",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                        // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
                {
                    key: "avgTopPostVelocity",
                    sortable: true,
                    label: "Top Post likes per hour",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                        // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
                {
                    key: "avgAvgVelocity",
                    sortable: true,
                    label: "Avg. Top9 likes per hour",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                        // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
                {
                    key: "avgMinVelocity",
                    sortable: true,
                    label: "Min. Top9 likes per hour",
                    formatter: (value) => {
                        if (typeof value === "undefined" || value === null) {
                            return 0;
                        }
                        return this.addCommaToNumber(value);
                        // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
            ],
        };
    },

    methods: {
        /**
         * SECTION - Manage wizard
         */
        isWizardStep(step) {
            if (this.currentWizardStep == step) {
                return "current";
            }
            return false;
        },
        setWizardStep(step) {
            this.currentWizardStep = step;
        },
        scrollToElement() {
            var el = this.$el.getElementsByClassName("search-results-block");
            setTimeout(() => {
                if (el.item(0)) {
                    el.item(0).scrollIntoView({ behavior: "smooth" });
                }
            }, 250);
        },
        /**
         * SECTION - Manage other
         */
        getSearchModes() {
            axios
                .get("searchmodes")
                .then((response) => {
                    // Set values
                    this.searchmodes = response.data.modes;
                    this.searchmodedefaults = response.data.defaults;
                    this.searchmodetitles = response.data.titles;
                    this.searchmodeshorttitles = response.data.shorttitles;
                    // Enable page display
                    this.pageIsReady = true;
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Stop preloader
                    this.pageIsLoaded = true;
                });
        },

        doHashtagSearch() {
            // Reset errors
            this.errors = [];

            // Start preloader
            this.resultsAreLoading = true;

            // Get parameters for option
            var form = this.$refs["hashtagSearchForm"];
            this.form.option = form.option.value;

            // Perform post
            axios
                .post("search", {
                    // Inputs
                    hashtags: this.form.hashtags,
                    likes: this.form.likes,
                    // Mode
                    mode: this.form.selectedMode,
                    option: this.form.option,
                    // Switches
                    useless: this.form.switches.useless,
                    relevant: this.form.switches.relevant,
                    smarttags: this.form.switches.smarttags,
                    getbanned: this.form.switches.getbanned,
                })
                .then((response) => {
                    // Prettify
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Get hashtag from query
                        var originalhashtag = response.data.initialhashtag;

                        // Generate title
                        var shorttitle = this.searchmodeshorttitles[this.form.selectedMode];
                        var title = "#" + originalhashtag + " - " + shorttitle;

                        // Manage search parameters
                        // Likes
                        var param_likes = "0 likes";
                        var param_haslikes = false;
                        if (this.form.likes > 0) {
                            param_likes = this.form.likes + " likes";
                            param_haslikes = true;
                        }
                        // Get short title
                        var param_mode = shorttitle;
                        if (this.form.selectedMode == 3 || this.form.selectedMode == 4) {
                            var param_option = "3 sets";
                        } else {
                            var param_option =
                                this.searchmodes[this.form.selectedMode][this.form.option].text;
                        }

                        // Manage colors
                        if (param_haslikes) {
                            if (this.form.selectedMode == 3 || this.form.selectedMode == 4) {
                                response.data.data.forEach((currentItem, index, theArray) => {
                                    currentItem.data.forEach(
                                        (currentSubItem, subIndex, subTheArray) => {
                                            // TODO - Check if is defined?
                                            theArray[index].data[subIndex]._rowVariant =
                                                this.returnHashtagRowColour(
                                                    this.form.likes,
                                                    currentSubItem
                                                );
                                            // Check if we don't have a ZERO
                                            // if (currentSubItem.avgAvgLikes != 0) {
                                            //     if (currentSubItem.status != "banned") {
                                            //         if (
                                            //             this.form.likes >
                                            //                 currentSubItem.avgMinLikes &&
                                            //             this.form.likes <
                                            //                 currentSubItem.avgAvgLikes * 1.1
                                            //         ) {
                                            //             theArray[index].data[subIndex]._rowVariant =
                                            //                 "warning";
                                            //         } else if (
                                            //             this.form.likes <=
                                            //             currentSubItem.avgMinLikes
                                            //         ) {
                                            //             theArray[index].data[subIndex]._rowVariant =
                                            //                 "danger";
                                            //         } else {
                                            //             theArray[index].data[subIndex]._rowVariant =
                                            //                 "success";
                                            //         }
                                            //     }
                                            // }
                                        }
                                    );
                                });
                            } else {
                                response.data.data.forEach((currentItem, index, theArray) => {
                                    theArray[index]._rowVariant = this.returnHashtagRowColour(
                                        this.form.likes,
                                        currentItem
                                    );
                                    // TODO - Check if is defined?
                                    // Check if we don't have a ZERO
                                    // if (currentItem.avgAvgLikes != 0) {
                                    //     if (currentItem.status != "banned") {
                                    //         if (
                                    //             this.form.likes > currentItem.avgMinLikes &&
                                    //             this.form.likes < currentItem.avgAvgLikes * 1.1
                                    //         ) {
                                    //             theArray[index]._rowVariant = "warning";
                                    //         } else if (this.form.likes <= currentItem.avgMinLikes) {
                                    //             theArray[index]._rowVariant = "danger";
                                    //         } else {
                                    //             theArray[index]._rowVariant = "success";
                                    //         }
                                    //     }
                                    // }
                                });
                            }
                        }

                        // Check if we have smart tags
                        var param_smart = false;
                        var smart = [];
                        if (typeof data.smarttags.data != "undefined") {
                            var param_smart = true;
                            var smart = data.smarttags.data;
                        }

                        // Add new tab
                        this.tabs.push({
                            title: title,
                            mode: this.form.selectedMode,
                            data: Object.values(response.data.data),
                            messages: Object.values(response.data.messages),
                            smart: smart,
                            currentpage: 1,
                            total_results: data.total_results,
                            slug: this.getSlug(),
                            search_parameters: {
                                likes: param_likes,
                                hasLikes: param_haslikes,
                                mode: param_mode,
                                options: param_option,
                                hashtag: originalhashtag,
                                smart: param_smart,
                            },
                        });

                        // Scroll down
                        this.scrollToElement();

                        // Get the newest tab index
                        var tabref = "tabsRefs-" + this.tabCount;
                        // Wait for it to generate before moving on
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.$refs[tabref][0].activate();
                                this.tabCount++;
                            }, 500);
                        });
                    }

                    // Check if we have a FAIL
                    if (data.status == "FAIL") {
                        if (data.messages.length > 0) {
                            data.messages.forEach((message) => {
                                this.errors.push({
                                    type: message.type,
                                    message: message.message,
                                });
                            });
                        }
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Start preloader
                    this.resultsAreLoading = false;
                });
        },

        changeTab(tabIndex) {
            var tabref = "tabsRefs-" + tabIndex;
            this.$refs[tabref][0].activate();
        },

        onRowClicked(tableid, item) {
            // Hack
            if (item.selected) {
                this.$set(item, "selected", false);
            } else {
                this.$set(item, "selected", true);
            }

            // Call getAllSelectItems
            this.getAllSelectedItems();
        },

        getAllSelectedItems() {
            // Get variable to store items
            var hSelection = [];

            // Generate array of all selected hashtags by table
            // Will this not use up a lot of memory?
            this.tabs.forEach((tab) => {
                // Switch mode
                if (tab.mode == 1 || tab.mode == 2) {
                    tab.data.forEach((item) => {
                        if (item.selected == true) {
                            hSelection.push(item.hashtag);
                        }
                    });
                } else if (tab.mode == 3 || tab.mode == 4) {
                    tab.data.forEach((subtab) => {
                        Object.values(subtab.data).forEach((item) => {
                            if (item.selected == true) {
                                hSelection.push(item.hashtag);
                            }
                        });
                    });
                }
            });

            // Remove duplicates
            hSelection = [...new Set(hSelection)];

            // Return variable
            this.selectedHashtags = hSelection;
        },

        onRowSelected(tableid, items) {
            // Get variable to store items
            var hSelection = [];

            // Generate array of all selected hashtags by table
            this.allSelectedHashtags[tableid] = { items };

            // Loop through all the tables
            Object.keys(this.allSelectedHashtags).forEach((key, value) => {
                // Loop through all the selected rows from each table
                this.allSelectedHashtags[key].items.forEach((item) => {
                    hSelection.push(item.hashtag);
                });
            });

            // Remove duplicates
            hSelection = [...new Set(hSelection)];

            // Return variable
            this.selectedHashtags = hSelection;
        },

        getSlug() {
            var result = "";
            var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            var charactersLength = characters.length;

            for (var i = 0; i < 10; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            return result;
        },

        selectFromSmart(tabIndex, hashtags) {
            // Loop through all the tab data
            this.tabs[tabIndex].data.forEach((part, index, theArray) => {
                if (hashtags.includes(part.hashtag)) {
                    this.$set(this.tabs[tabIndex].data[index], "selected", true);
                }
            });
            // Re-run the selection grabber
            this.getAllSelectedItems();
        },

        selectAll(tabIndex, mode) {
            if (mode == 1 || mode == 2) {
                // Loop through all the tab data
                this.tabs[tabIndex].data.forEach((part, index, theArray) => {
                    this.$set(this.tabs[tabIndex].data[index], "selected", true);
                });
            } else {
                this.tabs[tabIndex].data.forEach((subtab, subindex) => {
                    Object.values(subtab.data).forEach((part, index, theArray) => {
                        if (typeof this.tabs[tabIndex].data[subindex].data[index] != "undefined") {
                            this.$set(
                                this.tabs[tabIndex].data[subindex].data[index],
                                "selected",
                                true
                            );
                        }
                    });
                });
            }

            // Re-run the selection grabber
            this.getAllSelectedItems();
        },

        deselectAll(tabIndex, mode) {
            // Loop through all the tab data
            if (mode == 1 || mode == 2) {
                // Loop through all the tab data
                this.tabs[tabIndex].data.forEach((part, index, theArray) => {
                    this.$set(this.tabs[tabIndex].data[index], "selected", false);
                });
            } else {
                this.tabs[tabIndex].data.forEach((subtab, subindex) => {
                    Object.values(subtab.data).forEach((part, index, theArray) => {
                        if (typeof this.tabs[tabIndex].data[subindex].data[index] != "undefined") {
                            this.$set(
                                this.tabs[tabIndex].data[subindex].data[index],
                                "selected",
                                false
                            );
                        }
                    });
                });
            }
            // Re-run the selection grabber
            this.getAllSelectedItems();
        },

        hashHashtags(hashtags) {
            return "#" + hashtags.join(" #");
        },

        handleEmitMessages(messages) {
            if (messages.length > 0) {
                messages.forEach((currentItem) => {
                    this.errors.push({ type: currentItem.type, message: currentItem.message });
                });
            }
        },

        // NOTE - Keeping it here for smart hashtags
        initCopyHashtags() {
            var clipboard = new ClipboardJS(".copy-hashtags-button", {
                target: function (trigger) {
                    return trigger.nextElementSibling;
                },
            });

            clipboard.on("success", (e) => {
                e.trigger.children[1].innerText = "Copied!";
                setTimeout(() => {
                    e.trigger.children[1].innerText = this.button;
                }, 2000);
            });
        },
    },

    mounted() {
        this.initCopyHashtags();
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Search", route: "search" }]);
    },

    created() {
        this.getSearchModes();
    },

    computed: {
        displayResults: function () {
            if (this.tabs.length > 0) {
                return true;
            } else {
                return false;
            }
        },

        selectedHashtagsHashed() {
            return this.hashHashtags(this.selectedHashtags);
        },
    },
};
</script>
